import API from '../lib/API';
import { GenerateIssuesIndicator, GenerateMaintenancesIndicator, GetSchedule } from './contracts/Dashboard.contract';

const route = '/dashboard';

export function generateIssuesIndicator(body: GenerateIssuesIndicator.Body): Promise<GenerateIssuesIndicator.Response> {
    return API.post(`${route}/issues`, body);
}

export function generateMaintenancesIndicator(body: GenerateMaintenancesIndicator.Body): Promise<GenerateMaintenancesIndicator.Response> {
    return API.post(`${route}/maintenances`, body);
}

export function getSchedule(body: GetSchedule.Body): Promise<GetSchedule.Response> {
    return API.post(`${route}/schedule`, body);
}